import React from 'react';
import { BrowserRouter } from 'react-router-dom';

export const SMLRouter: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <BrowserRouter basename="/app">{children}</BrowserRouter>;
};
